import { NgModule, LOCALE_ID } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CurrencyPipe, registerLocaleData } from '@angular/common';
import localePtBR from '@angular/common/locales/pt';
registerLocaleData(localePtBR, 'pt-BR');

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';

import { NgIconsModule } from '@ng-icons/core';
import {
  heroHome,
  heroUser,
  heroCog6Tooth,
  heroArrowLeft,
  heroArrowRight,
  heroXMark,
  heroCheck,
  heroMagnifyingGlass,
  heroBell,
  heroBars3,
  heroChevronDown,
  heroChevronUp,
} from '@ng-icons/heroicons/outline';
import { lucideSettings, lucideLogOut, lucideSearch } from '@ng-icons/lucide';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { LayoutComponent } from './components/layout/layout.component';
import { GlassBackgroundComponent } from './components/glass-background/glass-background.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { BottomNavComponent } from './components/bottom-nav/bottom-nav.component';

import { LoginComponent } from './pages/auth/login/login.component';
import { MfaVerifyComponent } from './pages/auth/mfa-verify/mfa-verify.component';
import { MfaRequiredComponent } from './pages/auth/mfa-required/mfa-required.component';
import { ForgotPasswordComponent } from './pages/auth/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';

import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { UnauthorizedInterceptor } from './core/interceptors/unauthorized.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { BreadcrumbComponent } from './shared/breadcrumb/breadcrumb.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({ declarations: [
        AppComponent,
        LayoutComponent,
        GlassBackgroundComponent,
        SidebarComponent,
        HeaderComponent,
        BottomNavComponent,
        LoginComponent,
        MfaVerifyComponent,
        MfaRequiredComponent,
        ForgotPasswordComponent,
        ResetPasswordComponent,
        BreadcrumbComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        FormsModule,
        AppRoutingModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        MatSnackBarModule,
        MatMenuModule,
        MatTooltipModule,
        MatDividerModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatSelectModule,
        MatTabsModule,
        NgIconsModule.withIcons({
            heroHome,
            heroUser,
            heroCog6Tooth,
            heroArrowLeft,
            heroArrowRight,
            heroXMark,
            heroCheck,
            heroMagnifyingGlass,
            heroBell,
            heroBars3,
            heroChevronDown,
            heroChevronUp,
            lucideSettings,
            lucideLogOut,
            lucideSearch,
        }),
        TranslateModule.forRoot({
            defaultLanguage: 'pt-br',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        })], providers: [
        CurrencyPipe,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { panelClass: 'ngx-dialog', height: '75vh' } },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: UnauthorizedInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
